import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component, Ref, Prop } from '@eastsideco/salvo-ts';

@Component
export class DeliveryCountdown extends ThemeComponent {

}
